<template>
  <div class="selecet_products">
    <div class="subscription_wrap">
      <ProductList v-on:existRepeatItem="existRepeatItem"/>
      <div class="service_wrap bg_white pt16 pb48 mt12">
        <a href="#" class="btn_blue" @click.stop.prevent="confirmSubmit()">次へ</a>
        <div class="mt16">
          <button type="button" name="button" @click="closeWebView()" onClick="android.close()" class="back btn_delete">戻る</button>
        </div>
      </div>
    </div>
<ErrorModal v-show="isModalOpen" :errorMessage="errorMessage" @modalClose="modalClose" />
  </div>

</template>

<script>
import ProductList from '@/components/subscriptionMulti/ProductList'
import Config from '@/config/config'
import ErrorModal from '@/components/common/ErrorModal'
import scrollPosition from '@/model/scrollPosition';
import { mapGetters } from 'vuex';
import close from '@/model/closeWebView'

export default {
  props: [],
  components: {
    ProductList,
    ErrorModal
  },
  data () {
    return {
      isModalOpen: false,
      errorMessage: '商品が選択されていません',
      imagePath: Config.APIURL,
      subscriptionItems: []
    };
  },
  methods: {
    closeWebView() {
      close.closeWebView();
    },
    imageError(e) {
      e.target.src = e.target.dataset.noimage;
    },
    existRepeatItem(item) {
      this.subscriptionItems.push(...item);
    },
    confirmSubmit() {
      // localStorageから推奨商品データを取得
      const storedData = localStorage.getItem('recommendationRepeatItemList');
      let hasSelectedProducts = false;

      if (storedData) {
        try {
          const repeatItemList = JSON.parse(storedData);

          // データが配列であることを確認
          if (Array.isArray(repeatItemList)) {
            // 各BCでrepeatOrderがtrueの商品があるかチェック
            for (const bcItem of repeatItemList) {
              if (bcItem.bcItemList && Array.isArray(bcItem.bcItemList)) {
                for (const genreGroup of bcItem.bcItemList) {
                  // ジャンル別グループの場合
                  if (genreGroup.itemList && Array.isArray(genreGroup.itemList)) {
                    const hasRepeatOrder = genreGroup.itemList.some(item => item.repeatOrder === true);
                    if (hasRepeatOrder) {
                      hasSelectedProducts = true;
                      break;
                    }
                  }
                  // 直接商品オブジェクトの場合
                  else if (genreGroup.product && genreGroup.repeatOrder === true) {
                    hasSelectedProducts = true;
                    break;
                  }
                }
                if (hasSelectedProducts) break;
              }
              if (hasSelectedProducts) break;
            }
          }
        } catch (error) {
          console.warn('recommendationRepeatItemListのパースエラー:', error);
        }
      }

      // 選択商品があるか確認
      if (!hasSelectedProducts) {
        this.errorMessage = '商品が選択されていません。商品を選択してください。';
        this.modalOpen();
        return false;
      }

      this.$router.push({ name: 'multiSubSelectProductsList' });
    },
    modalOpen() {
      scrollPosition.open();
      this.isModalOpen = true;
    },
    modalClose() {
      scrollPosition.close();
      this.isModalOpen = false;
    }
  },
  computed: mapGetters([
    'recommendationRecommendProductMap'
  ]),
  created () {
  },
  watch: {
  }
}
</script>

<style lang="css" scoped>
.no_subscription_text {
  color: #747474;
  font-size: 16px;
  padding: 14px 14px 32px;
}
>>> .content_title {
  width: 173px;
}

>>> .product_list {
  display: flex;
  /* justify-content: space-between; */
  margin-top: 16px;
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  padding: 0 16px;
}

>>> .product_item {
  background: #FFFFFF;
  border: 1px solid #AAAAAA;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px 10px;
  position: relative;
  text-align: center;
  width: 120px;
}

>>> .subscription_wrap .product_item {
  background: #EBEBEB;
}


>>> .product_item:not(:first-child) {
  margin-left: 18px;
}

>>> .product_item::before {
  background: #F5F5F5;
  border: 1px solid #AAAAAA;
  border-radius: 100px;
  content: '';
  height: 20px;
  left: 6.61%;
  position: absolute;
  top: 4.21%;
  width: 20px;
}

>>> .product_item.select {
  background: #00FFFF;
  border: 2px solid #0E9AFF;
}

>>> .product_item.select::after {
  background: #00C2FF;
  border-radius: 100px;
  content: '';
  height: 12px;
  left: 13px;
  position: absolute;
  top: 14px;
  width: 12px;
}

>>> .beauty_wrap .product_item.select::after,
.goods_wrap .product_item.select::after,
.service_wrap .product_item.select::after {
  top: 14px;
}

>>> .product_image {
  width: 100px;
}

>>> .product_title {
  font-size: 8px;
  font-weight: bold;
  margin-top: 6px;
}

>>> .product_price {
  font-size: 18px;
}

>>> .product_point {
  font-size: 12px;
}

>>> .yen {
  font-size: 14px;
}

>>> .point {
  font-size: 10px;
}


.btn_blue {
  margin-top: 26px;
}

.subscription_wrap .btn_blue {
  margin-top: 17px;
}

.subscription_wrap .product_list {
  margin-top: 0;
}

.subscription_wrap .product_list {
  padding: 16px;
}

.subscription_item {
  background: #FFFFFF;
  border: 1px solid #AAAAAA;
  border-radius: 8px;
  position: relative;
  padding: 14px 10px;
  width: 120px;
}

.subscription_item:not(:first-child) {
  margin-left: 18px;
}

.item_count {
  align-items: center;
  border: 1px solid #AAAAAA;
  border-radius: 100px;
  display: flex;
  height: 26px;
  justify-content: center;
  left: 8px;
  line-height: 1;
  position: absolute;
  top: 8px;
  width: 26px;
}

.item_image {
  height: 90px;
  margin: auto;
  width: 100px;
}

.item_image img {
  height: 100%;
}

.item_name {
  font-size: 10px;
  margin-top: 5px;
  text-align: center;
  white-space: pre-wrap;
}

.btn_back {
  margin-top: 26px;
}

</style>



// WEBPACK FOOTER //
// src/views/subscriptionMultiBc/SubSelectProducts.vue